export const COLOR = {
  acento: "#5656ff",
  acentoSuave: "#ececff",
  titulo: "#0b0060",
  texto: "#3f3f46",
  textoSuave: "#71717a",
  borde: "#e4e4e7",
  panel: "#ffffff",
  fondoLienzo: "#eef0f4",
  plano: "#ffffff",
  puntoGrilla: "#d4d4d8",
  vendido: "#a1a1aa",
};

export const ALTO_BARRA = 60;
export const FUENTE = "Bricolage Grotesque";
export const ANCHO_PANEL_IZQ = 232;
export const ANCHO_PANEL_DER = 320;

// rgba con transparencia a partir de un color #rrggbb
export const conAlfa = (hex, alfa) => {
  const limpio = (hex || COLOR.acento).replace("#", "");
  const n = parseInt(limpio.length === 3 ? limpio.replace(/./g, "$&$&") : limpio, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alfa})`;
};
